import { render, staticRenderFns } from "./PopoverContent.vue?vue&type=template&id=05b67f90&"
import script from "./PopoverContent.vue?vue&type=script&lang=js&"
export * from "./PopoverContent.vue?vue&type=script&lang=js&"
import style0 from "./PopoverContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports